import * as React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  z-index: 2147483001;
  box-sizing: border-box;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  width: 100%;
  color: rgb(115, 115, 118);
  background: transparent;
  margin: 0px;
  padding: 0px;
`

const Title = styled.div`
  font-size: 14px;
  width: 100%;
  color: rgb(115, 115, 118);
  background: transparent;
  margin: 0px;
  text-align: center;
`

const Icons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Icon = styled.div`
  font-size: 28px;
  width: 52px;
  height: 40px;
  display: inline-flex;
  justify-content: center;
  transition: transform 0.04s;
  cursor: pointer;
  &:hover {
    transform: scale(1.32);
  }
`

interface IProps {
  title: string
  reactions: {
    emoji: string
    onClick: () => void
  }[]
}

const Reactions = (props: IProps) => {
  const { title, reactions } = props
  return (
    <Container>
      <Wrapper>
        <Title>{title}</Title>

        <Icons>
          {reactions.map((reaction, index) => (
            <Icon key={index} onClick={reaction.onClick}>
              {reaction.emoji}
            </Icon>
          ))}
        </Icons>
      </Wrapper>
    </Container>
  )
}

export default Reactions